import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Card from '../components/ui/Card'

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8">
            <h1 className="text-3xl font-bold mb-6 text-center">নিয়মাবলী ও শর্তাবলী</h1>
            <p className="text-sm text-gray-500 mb-8 text-center">সর্বশেষ আপডেট: ২৫ সেপ্টেম্বর, ২০২৫</p>

            <div className="space-y-6">
              <section>
                <h2 className="text-2xl font-semibold mb-4">১. সেবার বর্ণনা</h2>
                <p className="text-gray-700 leading-relaxed">
                  ফজরফাইটার একটি ইসলামিক সেবা যা মুসলিম উম্মাহকে ফজরের নামাজের জন্য সময়মতো জাগানোর
                  উদ্দেশ্যে স্বয়ংক্রিয় কল এবং কমিউনিটি ভিত্তিক জাগরণ সেবা প্রদান করে। এই সেবা সম্পূর্ণ
                  বিনামূল্যে এবং ইসলামিক মূল্যবোধের ভিত্তিতে পরিচালিত।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">২. সেবার শর্তাবলী</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  আমাদের সেবা ব্যবহার করার জন্য আপনাকে নিম্নলিখিত শর্তাবলীতে সম্মত হতে হবে:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>আপনি কমপক্ষে ১৩ বছর বয়সী এবং সঠিক তথ্য প্রদান করছেন</li>
                  <li>আপনার মোবাইল নাম্বার সক্রিয় এবং কল রিসিভ করতে সক্ষম</li>
                  <li>আপনি ফজরের সময় কল রিসিভ করতে সম্মত</li>
                  <li>আপনি কমিউনিটির অন্যান্য সদস্যদের সাথে সম্মানজনক আচরণ করবেন</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৩. ব্যবহারকারীর দায়িত্ব</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  ব্যবহারকারী হিসেবে আপনার দায়িত্ব:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>সঠিক এবং আপডেট তথ্য প্রদান করা</li>
                  <li>অ্যাকাউন্টের নিরাপত্তা রক্ষা করা</li>
                  <li>অন্যান্য ব্যবহারকারীদের গোপনীয়তা সম্মান করা</li>
                  <li>সেবার অপব্যবহার না করা</li>
                  <li>ইসলামিক শিষ্টাচার বজায় রাখা</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৪. নিষিদ্ধ কার্যকলাপ</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  নিম্নলিখিত কার্যকলাপ কঠোরভাবে নিষিদ্ধ:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>মিথ্যা তথ্য প্রদান করা</li>
                  <li>অন্যের অ্যাকাউন্ট ব্যবহার করা</li>
                  <li>স্প্যামিং বা অনুপযুক্ত কন্টেন্ট পাঠানো</li>
                  <li>সিস্টেমের নিরাপত্তায় হস্তক্ষেপ করা</li>
                  <li>অন্যান্য ব্যবহারকারীদের হয়রানি করা</li>
                  <li>বাণিজ্যিক উদ্দেশ্যে সেবার অপব্যবহার</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৫. কল সেবার শর্তাবলী</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  স্বয়ংক্রিয় কল সেবার ক্ষেত্রে:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>কল সময় স্থানীয় ফজরের সময় অনুযায়ী নির্ধারিত হবে</li>
                  <li>নেটওয়ার্ক সমস্যার কারণে কল না পৌঁছানোর জন্য আমরা দায়ী নই</li>
                  <li>আপনি যেকোনো সময় কল সেবা বন্ধ করতে পারেন</li>
                  <li>কল রিসিভ না করার জন্য কোনো জরিমানা নেই</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৬. কমিউনিটি সেবা</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  কমিউনিটি ভিত্তিক সেবার শর্তাবলী:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>কমিউনিটি সদস্যদের মধ্যে পারস্পরিক সম্মান বজায় রাখতে হবে</li>
                  <li>গোপনীয়তা রক্ষা করতে হবে</li>
                  <li>অনুপযুক্ত আচরণের জন্য সদস্যপদ বাতিল হতে পারে</li>
                  <li>কমিউনিটি অ্যাডমিনের নির্দেশনা মেনে চলতে হবে</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৭. দায়বদ্ধতার সীমাবদ্ধতা</h2>
                <p className="text-gray-700 leading-relaxed">
                  ফজরফাইটার একটি সহায়ক সেবা। আমরা নিম্নলিখিত ক্ষেত্রে দায়ী নই:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-3">
                  <li>প্রযুক্তিগত ত্রুটির কারণে কল না পৌঁছানো</li>
                  <li>নেটওয়ার্ক সমস্যা বা মোবাইল অপারেটরের সমস্যা</li>
                  <li>ব্যবহারকারীর ভুল তথ্য প্রদানের ফলাফল</li>
                  <li>তৃতীয় পক্ষের সেবার সমস্যা</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৮. গোপনীয়তা</h2>
                <p className="text-gray-700 leading-relaxed">
                  আমরা আপনার ব্যক্তিগত তথ্যের গোপনীয়তা রক্ষা করি। বিস্তারিত জানতে আমাদের
                  <a href="/privacy-policy" className="text-blue-600 hover:underline"> গোপনীয়তা নীতি</a>
                  দেখুন। আমরা আপনার তথ্য শুধুমাত্র সেবা প্রদানের জন্য ব্যবহার করি।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">৯. সেবা বন্ধকরণ</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  আমরা নিম্নলিখিত কারণে আপনার অ্যাকাউন্ট বন্ধ করতে পারি:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>নিয়মাবলী লঙ্ঘন</li>
                  <li>অনুপযুক্ত আচরণ</li>
                  <li>মিথ্যা তথ্য প্রদান</li>
                  <li>সেবার অপব্যবহার</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-3">
                  আপনিও যেকোনো সময় আপনার অ্যাকাউন্ট বন্ধ করতে পারেন।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">১০. বুদ্ধিবৃত্তিক সম্পত্তি</h2>
                <p className="text-gray-700 leading-relaxed">
                  ফজরফাইটার প্ল্যাটফর্মের সমস্ত কন্টেন্ট, ডিজাইন এবং ফিচার আমাদের বুদ্ধিবৃত্তিক সম্পত্তি।
                  অনুমতি ছাড়া এগুলো ব্যবহার, কপি বা বিতরণ করা যাবে না।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">১১. প্রযোজ্য আইন</h2>
                <p className="text-gray-700 leading-relaxed">
                  এই নিয়মাবলী বাংলাদেশের আইন অনুযায়ী পরিচালিত হবে। কোনো বিরোধের ক্ষেত্রে
                  ঢাকার আদালতের এখতিয়ার প্রযোজ্য হবে।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">১২. নিয়মাবলী পরিবর্তন</h2>
                <p className="text-gray-700 leading-relaxed">
                  আমরা প্রয়োজন অনুযায়ী এই নিয়মাবলী পরিবর্তন করতে পারি। গুরুত্বপূর্ণ পরিবর্তনের
                  ক্ষেত্রে ব্যবহারকারীদের অবহিত করা হবে। পরিবর্তনের পরেও সেবা ব্যবহার করলে
                  নতুন নিয়মাবলীতে সম্মতি বলে গণ্য হবে।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">১৩. ইসলামিক নৈতিকতা</h2>
                <p className="text-gray-700 leading-relaxed">
                  এই সেবা ইসলামিক মূল্যবোধের ভিত্তিতে পরিচালিত। সকল ব্যবহারকারীকে ইসলামিক
                  শিষ্টাচার বজায় রাখতে হবে এবং হালাল উপায়ে সেবা ব্যবহার করতে হবে।
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">১৪. যোগাযোগ</h2>
                <p className="text-gray-700 leading-relaxed">
                  এই নিয়মাবলী সম্পর্কে কোনো প্রশ্ন থাকলে আমাদের সাথে যোগাযোগ করুন:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg mt-4">
                  <p><strong>সাহায্য, ডোনেশন, স্পন্সর, সাজেশন, বাগ, রিপোর্টসহ যে কোনো প্রয়োজনে:</strong></p>
                  <p><strong>WhatsApp:</strong> +880 1314-951751</p>
                  <p><strong>WhatsApp:</strong> +880 1703-788889</p>
                  <p><strong>ঠিকানা:</strong> ঢাকা, বাংলাদেশ</p>
                </div>
              </section>

              <section className="border-t pt-6">
                <p className="text-sm text-gray-500 text-center">
                  আমাদের সেবা ব্যবহার করার মাধ্যমে আপনি এই নিয়মাবলীতে সম্মত হচ্ছেন।<br />
                  আল্লাহ তায়ালা আমাদের সকলকে নিয়মিত ফজরের নামাজ আদায়ের তাওফীক দান করুন। আমীন।
                </p>
              </section>
            </div>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default TermsAndConditions